import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useMemo } from 'react';
import { useKeySelector } from '../../../hooks/useKeySelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useKeySelectorWidget = () => {
    const { component: keySelector } = useKeySelector({
        initialRequiredKeys: ['Required Attribute 0'],
        initialKeys: ['Attribute 1', 'Attribute 2'],
    });
    const component = useMemo(() => _jsx(Stack, { direction: "row", children: keySelector }), [keySelector]);
    return {
        name: 'useKeySelector',
        category: 'hooks',
        component,
    };
};
